<template>
	<div class="d-flex flex-column flex h100">
		<div class="navbar theme-login bg box-shadow" style="min-height: 64px;">
			<div>
				<a href="javascript:void(0)" class="navbar-brand oscar-logo">
					<img :src="brand.logoHeader" alt="." class />
				</a>
			</div>
			<i
				v-if="!loggedOut"
				class="fas fa-2x fa-power-off clickable-text"
				v-tippy
				title="Log Out"
				@click="logout()"
			/>
		</div>
		<div class="app" v-if="!loggedOut">
			<div class="app-content">
				<div class="content-main">
					<div class="container-fluid d-flex flex-column h-100 position-relative">
						<div class="top-right" v-if="!selectedAssignment && hiddenDelivs > 0">
							<button class="btn white" data-toggle="dropdown" aria-expanded="false">
								<i class="fas fa-ellipsis-v faw"></i>
							</button>
							<div class="dropdown-menu dropdown-menu-right">
								<a
									v-if="!showAll"
									class="dropdown-item d-flex flex-row align-items-center"
									@click="showAll = true"
								>
									<i class="far fa-eye fa-lg"></i>
									<div class="mb-0">Show More Assignments</div>
								</a>
								<a
									v-if="showAll"
									class="dropdown-item d-flex flex-row align-items-center"
									@click="showAll = false"
								>
									<i class="far fa-eye-slash fa-lg"></i>
									<div class="mb-0">Show Fewer Assignments</div>
								</a>
							</div>
						</div>
						<div class="text-center mt-4 mb-3" v-if="user">
							<h3 class="mb-0">Hello, {{ user.first_name }}!</h3>
							<template v-if="visibleDelivs != 0">
								<h5 class="mb-0 text-muted _400" v-if="!selectedAssignment">Choose an assignment</h5>
								<h5 class="mb-0 text-muted _400" v-if="selectedAssignment">Upload work</h5>
							</template>
						</div>
						<div
							class="flex row justify-content-center"
							style="overflow: hidden;"
							v-if="selectedAssignment"
						>
							<div class="px-3 pb-3 col-sm-12 col-md-10 col-lg-8 h-100">
								<div class="box border h-100 d-flex flex-column mb-0">
									<div class="box-header py-4">
										<h3 class="d-flex flex-row align-items-center">
											<div class="flex mr-2">
												{{ selectedClass.name }}
												<i class="fas fa-angle-right fa-fw" />
												{{ selectedAssignment.name }}
											</div>
											<a v-if="selectedAssignment.students_notes" class="float-right clickable-back" @click="showNotes()">{{this.showItText}}</a>

											<a class="float-right clickable-back" @click="finished()">Back</a>
										</h3>
									</div>
																		<div v-if="showIt" class="box-header py-4">
										<span class="d-flex border flex-row align-items-center"  style="padding: 10px">
											<div class=" flex mr-2">
  <div v-html="selectedAssignment.students_notes"></div>

											</div>
										</span>

									</div>
									<template
										v-if="!(selectedAssignment.beforeWindow || selectedAssignment.afterWindow)"
									>
										<template
											v-if="
												!(
													selectedAssignment.response &&
													selectedAssignment.response.media.length
												)
											"
										>
											<div
												class="flex box-body pt-0 d-flex flex-column"
												style="overflow: hidden;"
											>
												<vue-dropzone
													v-show="uploadFrom == 'computer'"
													ref="myVueDropzone"
													id="dropzone"
													class="h-100"
													:options="dropzoneOptions"
													@vdropzone-sending="sendingEvent"
													:useCustomSlot="true"
													@vdropzone-error="dropzoneError"
													@vdropzone-queue-complete="finished"
													@vdropzone-files-added="removeIfUnsupported"
												>
													<div class="dropzone-custom-content">
														<i class="fas fa-file-alt fa-5x mb-4" />
														<h3 class="dropzone-custom-title">
															Drag and drop to upload content
														</h3>
														<div class="subtitle">
															...or click/tap to select a file from your computer/device
														</div>
													</div>
												</vue-dropzone>
												<vue-dropzone
													v-show="uploadFrom == 'camera'"
													ref="myVueDropzoneCamera"
													id="dropzoneCamera"
													class="h-100"
													:options="dropzoneCameraOptions"
													@vdropzone-sending="sendingEvent"
													:useCustomSlot="true"
													@vdropzone-error="dropzoneError"
													@vdropzone-queue-complete="finished"
												>
													<div class="dropzone-custom-content">
														<i class="fas fa-camera fa-5x mb-4" />
														<h3 class="dropzone-custom-title">
															Click/tap to take a picture
														</h3>
													</div>
												</vue-dropzone>
												<div class="h-100" v-if="uploadFrom == 'google'">
													<loading
														v-if="!isSignedIn"
														type="large"
														class="text-center"
														style="font-size: 10rem;"
													/>
													<google-drive-file-picker
														v-if="isSignedIn"
														:refresh="googleUser"
														:files.sync="googleFiles"
														class="h-100"
													/>
												</div>
											</div>
											<div class="box-footer pt-0 d-flex flex-row">
												<button class="btn theme-login text-white mr-3" data-toggle="dropdown">
													Upload From...
													<i class="fas fa-caret-up fa-fw" />
												</button>
												<div class="dropdown-menu dropdown-menu-left">
													<a
														class="dropdown-item d-flex flex-row align-items-center"
														@click="uploadFrom = 'computer'"
														:class="{ active: uploadFrom == 'computer' }"
													>
														<i class="fas fa-lg fa-window"></i>
														<div class="mb-0">My files</div>
													</a>
													<a
														v-if="canUseCamera"
														class="dropdown-item d-flex flex-row align-items-center"
														@click="uploadFrom = 'camera'"
														:class="{ active: uploadFrom == 'camera' }"
													>
														<i class="fas fa-lg fa-camera"></i>
														<div class="mb-0">Camera</div>
													</a>
													<a
														v-if="canUseGoogle"
														class="dropdown-item d-flex flex-row align-items-center"
														@click="pickGoogleUpload"
														:class="{ active: uploadFrom == 'google' }"
													>
														<i class="fab fa-lg fa-google-drive"></i>
														<div v-if="!googleUser" class="mb-0">Google Drive</div>
														<div v-if="googleUser" class="mb-0">
															{{ googleUser.getName() }}'s Google Drive
														</div>
													</a>
													<a
														class="dropdown-item d-flex flex-row align-items-center"
														@click="changeUser"
														v-if="canUseGoogle && googleUser"
													>
														<i class="fab fa-lg fa-none"></i>
														<div class="mb-0">Log out Google user...</div>
													</a>
													
												</div>												
												<button class="btn theme-login text-white mr-3" 													
													v-tippy
													title="Record and submit an audio file"
													@click="openRecordModal()">
													
													<i class="fas fa-microphone fa-fw" />
												</button>
												
												<template v-if="!submitting">
													<button
														v-if="uploadFrom == 'computer'"
														@click="saveFiles('myVueDropzone')"
														class="btn theme-login text-white flex"
													>
														Submit
													</button>
													
													<button
														v-if="uploadFrom == 'camera'"
														@click="saveFiles('myVueDropzoneCamera')"
														class="btn theme-login text-white flex"
													>
														Submit
													</button>
													<button
														v-if="
															uploadFrom == 'google' &&
																!(googleFiles && googleFiles.length > 0)
														"
														disabled
														class="btn theme-login text-white flex"
													>
														Submit
													</button>
													<button
														v-if="
															uploadFrom == 'google' &&
																googleFiles &&
																googleFiles.length > 0
														"
														@click="saveGoogleFiles()"
														class="btn theme-login text-white flex"
													>
														Submit ({{ googleFiles.length }})
													</button>
												</template>
												<button
													v-if="submitting"
													@click="saveFiles()"
													class="btn theme-login text-white flex"
													disabled
												>
													Submitting...
													<loading type="icon" />
												</button>
											</div>
										</template>
										<template
											v-if="
												selectedAssignment.response && selectedAssignment.response.media.length
											"
										>
											<div class="flex box-body pt-0">
												<div
													class="text-center w-100 h-100 d-flex flex-column justify-content-center"
												>
													<i
														class="far fa-file-check mb-3 text-muted"
														style="font-size: 10rem"
													/>
													<h3 class="mb-0 text-muted">Work Submitted</h3>
													<div class="text-muted text-md">
														You already have work submitted for this assignment
													</div>
													<div class="text-muted">
														If you didn't upload it yourself, your teacher may have done it
														for you
													</div>
												</div>
											</div>
											<div class="box-footer text-center"></div>
										</template>
									</template>
									<template v-if="selectedAssignment.beforeWindow || selectedAssignment.afterWindow">
										<div class="flex box-body pt-0">
											<div
												class="text-center w-100 h-100 d-flex flex-column justify-content-center"
											>
												<i class="far fa-clock mb-3 text-muted" style="font-size: 10rem" />
												<h3 class="mb-0 text-muted">
													This assignment is not currently available
												</h3>
												<div v-if="selectedAssignment.afterWindow" class="text-muted text-md">
													The deadline was
													<span class="text-danger _600">{{
														fs.medDate(selectedAssignment.window_end)
													}}</span>
												</div>
												<div v-if="selectedAssignment.beforeWindow" class="text-muted text-md">
													Come back after
													<span class="text-primary _600">{{
														fs.medDate(selectedAssignment.window_start)
													}}</span>
												</div>
											</div>
										</div>
										<div class="box-footer text-center"></div>
									</template>
								</div>
							</div>
						</div>

						<div v-if="user && !selectedClass">
							<div
								class="flex row justify-content-center"
								v-if="showAll ? visibleDelivs + hiddenDelivs == 0 : visibleDelivs == 0"
							>
								<div class="px-3 pb-3 col-sm-12 col-md-10 col-lg-8">
									<div
										class="text-center h-100 d-flex flex-column justify-content-center box border p-5"
									>
										<i class="far fa-file-exclamation mb-3 text-muted" style="font-size: 10rem" />
										<h3 class="mb-0 text-muted">No open assignments</h3>
									</div>
								</div>
							</div>
							<template v-for="cl in classes">
								<div v-if="cl.anyShown || showAll" class="row justify-content-center" :key="cl.id">
									<div class="px-3 pb-3 col-sm-12 col-md-10 col-lg-8">
										<div class="box border mb-0">
											<div class="box-header">
												<h3>{{ cl.name }}</h3>
											</div>

											<div class>
												<table class="table mb-0">
													<thead>
														<tr>
															<th class="p-custom px-3 py-1">Activities</th>
															<th style="width: 80px;"></th>
														</tr>
													</thead>
													<tbody>
														<template v-for="delivery in cl.deliveries">
															<template
																v-if="!(delivery.beforeWindow || delivery.afterWindow)"
															>
																<tr
																	:key="delivery.id"
																	v-if="
																		delivery.response &&
																			delivery.response.media.length
																	"
																	:class="{
																		'selected-submitted':
																			cl.id == qClassID &&
																			delivery.id == qDeliveryID
																	}"
																>
																	<td class="p-custom px-3 py-2">
																		{{ delivery.name }}
																		<span v-if="delivery.pretest">(Pre-Test)</span>
																		<span v-if="delivery.posttest"
																			>(Post-Test)</span
																		>
																	</td>
																	<td
																		class="text-right p-custom px-3"
																		style="padding-top: 6.5px; padding-bottom: 6.5px;"
																	>
																		<span class="badge success p-1 text-u-c"
																			>Submitted</span
																		>
																	</td>
																</tr>
																<tr
																	:key="delivery.id"
																	v-if="
																		!delivery.response ||
																			!delivery.response.media.length
																	"
																	class="clickable"
																	@click="select(cl, delivery)"
																	:class="{
																		'selected-row':
																			cl.id == qClassID &&
																			delivery.id == qDeliveryID
																	}"
																>
																	<td class="p-custom px-3 py-2">
																		<i
																			v-if="
																				cl.id == qClassID &&
																					delivery.id == qDeliveryID
																			"
																			class="fa fa-lg mr-1 fa-angle-right text-primary"
																		/>
																		{{ delivery.name }}
																		<span v-if="delivery.pretest">(Pre-Test)</span>
																		<span v-if="delivery.posttest"
																			>(Post-Test)</span
																		>
																	</td>
																	<td
																		class="text-right p-custom px-3"
																		style="padding-top: 6.5px; padding-bottom: 6.5px;"
																	>
																		<span class="badge primary p-1 text-u-c pointer"
																			>Upload</span
																		>
																	</td>
																</tr>
															</template>
															<template
																v-if="
																	(delivery.beforeWindow || delivery.afterWindow) &&
																		showAll
																"
															>
																<tr
																	:key="delivery.id"
																	v-if="delivery.beforeWindow"
																	class="text-extra-muted"
																>
																	<td class="p-custom px-3 py-2">
																		{{ delivery.name }}
																		<span v-if="delivery.pretest">(Pre-Test)</span>
																		<span v-if="delivery.posttest"
																			>(Post-Test)</span
																		>
																	</td>
																	<td
																		class="text-right p-custom px-3"
																		style="padding-top: 6.5px; padding-bottom: 6.5px;"
																	>
																		<span
																			class="badge badge-secondary p-1 text-u-c"
																			style="opacity: 0.5;"
																			v-tippy
																			:title="beforeWindowTooltip(delivery)"
																			>Not Started</span
																		>
																	</td>
																</tr>
																<tr
																	:key="delivery.id"
																	v-if="delivery.afterWindow"
																	class="text-extra-muted"
																>
																	<td class="p-custom px-3 py-2">
																		{{ delivery.name }}
																		<span v-if="delivery.pretest">(Pre-Test)</span>
																		<span v-if="delivery.posttest"
																			>(Post-Test)</span
																		>
																	</td>
																	<td
																		class="text-right p-custom px-3"
																		style="padding-top: 6.5px; padding-bottom: 6.5px;"
																	>
																		<span
																			class="badge badge-secondary p-1 text-u-c"
																			style="opacity: 0.5;"
																			v-tippy
																			:title="afterWindowTooltip(delivery)"
																			>Ended</span
																		>
																	</td>
																</tr>
															</template>
														</template>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="app" v-if="loggedOut">
			<div class="text-center mt-4 mb-3 w-100" v-if="user">
				<h3 class="mb-0">Goodbye, {{ user.first_name }}!</h3>
			</div>
		</div>
		<div class="p-3 b-t mt-auto theme-login">© 2021 Copyright MZ Development v{{ version }}</div>
		<div class="modal" id="recordModal" >

			<div v-if="renderComponent" class="modal-dialog">
				<div >
			  <audio-recorder
    :upload-url="dropzoneOptions.audio_url"
    :attempts="1"
	:headers="headers"
	:before-upload="callback"
/>

				</div>
			</div>
		</div>
	</div>
	
</template>

<script>



import AuthService from "@/services/AuthService";
import Notie from "@/services/NotieService";
import store from "@/services/Store";
import Router from "@/router";
import BrandService from "@/services/BrandService";
import ThemeService from "@/services/ThemeService";
import moment from "moment";
import fs from "@/services/FormatService";
import $ from "jquery";

import BB from "bluebird";
var brand = BrandService.getBrand();

import UserService from "@/services/UserService";
import ResponseMediaService from "@/services/ResponseMediaService";
import GoogleDriveFilePicker from "@/components/GoogleDriveFilePicker";

// import { QrcodeStream } from "vue-qrcode-reader";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import pack from "../../../package.json";

// import Instascan from "instascan";

var unsupportedMTs = [
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/vnd.ms-excel",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"application/vnd.ms-powerpoint",
	"application/vnd.openxmlformats-officedocument.presentationml.presentation",
	"text/csv"
];
export default {
	name: "SubmitWork",
	components: {
		vueDropzone: vue2Dropzone,
		googleDriveFilePicker: GoogleDriveFilePicker
	},
	data() {
		let testInput = document.createElement("input");
		testInput.setAttribute("capture", true);
		let canUseCamera = !!testInput["capture"];

		return {
			headers :{
			'Content-Type': 'audio/mpeg'
			},
			fs: fs,

			firstLoad: true,
			qClassID: null,
			qDeliveryID: null,

			brand: brand,
			error: "",
			result: "",
			version: pack.version,
			user: null,

			classes: [],
			responses: [],
			assessments: [],

			selectedClass: null,
			selectedAssignment: null,
			showAll: false,
			visibleDelivs: 0,
			hiddenDelivs: 0,

			canUseCamera: canUseCamera,
			canUseGoogle: false,
			uploadFrom: canUseCamera ? "camera" : "computer",
			gapi: gapi,
			googleAuth: null,
			googleUser: null,
			isSignedIn: null,
			googleFiles: [],
			submitting: false,

			dropzoneOptions: {
				// url: 'https://httpbin.org/post',
				autoProcessQueue: false,
				thumbnailWidth: 300,
				maxFilesize: 10.5,
				addRemoveLinks: true
			},

			dropzoneCameraOptions: {
				// url: 'https://httpbin.org/post',
				autoProcessQueue: false,
				thumbnailWidth: 300,
				maxFilesize: 10.5,
				addRemoveLinks: true,
				capture: "camera"
			},

			loggedOut: false,
			showIt:true,
			showItText: "Hide Notes",
			renderComponent: true,
			AudioIsUploaded: false

		};
	},
	created() {

		// AuthService.clearState();
		var url = location.href;
		var host = location.host;
		if (url.indexOf("https") == -1 && url.indexOf("localhost") == -1 && url.indexOf("192.168.") == -1) {
			location.href = "https://" + host;
		}
		this.loadData();

		BrandService.load();
		ThemeService.setTheme(BrandService.getBrand().defaultTheme);

		// var id = this.$route.params.studentID;
		// if (id) {
		// 	UserService.getAvailableAssessments(id).then(results => {
		// 		this.user = results.data.student;
		// 		this.classes = results.data.classes;
		// 		this.responses = results.data.responses;
		// 		this.assessments = results.data.assessments;

		// 		_.each(this.classes, c => {
		// 			_.each(c.deliveries, d => {
		// 				d.response = _.find(this.responses, {
		// 					delivery_id: d.id
		// 				});
		// 			});
		// 		});

		// 		// debugger;
		// 	});
		// }

		let clientId = "858905472313-fo0bitsgfq8umudeq25c8jro3f8h06p2.apps.googleusercontent.com";
		let apiKey = "AIzaSyAz1yrFwxIoZCdRVPCjzs5U-KYYIwtBIxE";
		gapi.load("client", () => {
			gapi.client
				.init({
					apiKey: apiKey,
					clientId: clientId,
					scope: "https://www.googleapis.com/auth/drive.readonly",
					discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"]
				})
				.then(() => {
					console.log("Initialized Google API");
					this.canUseGoogle = true;
					if (!this.googleAuth) {
						console.log("Create auth object 1");
						this.googleAuth = gapi.auth2.getAuthInstance();
						this.googleAuth.currentUser.listen(resp => {
							console.log("USER LISTENER 1", resp);

							this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();

							let id = this.$route.params.studentID;
							store.set(this, "allowedGoogleSession", {
								[id]: this.googleUser.getId()
							});
							console.log("Set allowedGoogleSession", id, this.googleUser.getId());
						});
						this.googleAuth.isSignedIn.listen(resp => {
							console.log("LISTENER 1", resp);
							this.isSignedIn = this.googleAuth.isSignedIn.get();
							if (!this.isSignedIn) {
								this.googleUser = null;
								this.isSignedIn = null;
							}
						});

						this.isSignedIn = this.googleAuth.isSignedIn.get();

						if (this.isSignedIn) {
							this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();

							this.ensureSavedSession();
						}
					}
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to initialize Google API");
				});
		});
	},

	mounted() {

		this.$eventBus.$on('end-upload', () => {
			console.log("Audio Uploaded SUCCESSFULLY")
			this.AudioIsUploaded = true;
			this.hideRecordModal();


})
	},

	watch: {

    AudioIsUploaded: function (val) {
	  console.log(val)
	Notie.success("Recording was successfully uploaded and submitted");

	  this.finished()
    },
	},

	methods: {		openRecordModal() {

			$("#recordModal").modal();
		},
				hideRecordModal() {


			$("#recordModal").modal("toggle");
		},
		      callback () {
	  },
	  		recordAudio() {
			$("#recordModal").modal();
		},
		parseQuery() {
			this.qClassID = this.$route.query.c;
			this.qDeliveryID = this.$route.query.d;
			if (!(this.qClassID && this.qDeliveryID && this.firstLoad)) {
				return;
			}

			this.firstLoad = false;
			_.each(this.classes, cl => {
				if (cl.id == this.qClassID) {
					_.each(cl.deliveries, delivery => {
						if (delivery.id == this.qDeliveryID) {
							this.select(cl, delivery);
						}
					});
				}
			});
		},

		select(cl, delivery) {
			this.forceRerender();
			this.selectedClass = cl;
			this.selectedAssignment = delivery;
			this.selectedAssessment = _.find(this.assessments, {
				id: delivery.assessment_id
			});
			let studentID = this.$route.params.studentID;
			this.dropzoneOptions.url = `/v3/external/response_media/${cl.id}/${delivery.assessment_id}/${delivery.id}/${this.selectedAssessment.item.id}/${studentID}`;
			this.dropzoneOptions.audio_url = `/v3/external/response_media_audio/${cl.id}/${delivery.assessment_id}/${delivery.id}/${this.selectedAssessment.item.id}/${studentID}`;

			this.dropzoneCameraOptions.url = `/v3/external/response_media/${cl.id}/${delivery.assessment_id}/${delivery.id}/${this.selectedAssessment.item.id}/${studentID}`;
		},
        forceRerender() {
      // Remove my-component from the DOM

      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
		loadData() {
			var id = this.$route.params.studentID;
			if (id) {
				UserService.getAvailableAssessments(id).then(results => {
					this.user = results.data.student;
					this.classes = results.data.classes;
					this.responses = results.data.responses;
					this.assessments = results.data.assessments;
					this.showIt = true;
					this.showItText = 'Hide Notes',
					this.visibleDelivs = 0;
					this.hiddenDelivs = 0;
					let lastVisibleClass = null;
					let lastVisibleDeliv = null;
					_.each(this.classes, c => {
						c.anyShown = false;
						_.each(c.deliveries, d => {
							if (d.window_start) {
								d.startDate = moment(d.window_start);
								d.beforeWindow = moment().isBefore(d.startDate);
							}
							if (d.window_end) {
								d.endDate = moment(d.window_end);
								d.afterWindow = moment().isAfter(d.endDate);
							}
							if (d.beforeWindow || d.afterWindow) {
								this.hiddenDelivs++;
							} else {
								lastVisibleClass = c;
								lastVisibleDeliv = d;
								this.visibleDelivs++;
								c.anyShown = true;
							}

							d.response = _.find(this.responses, {
								delivery_id: d.id
							});
						});
					});

					this.parseQuery();
					if (!this.selectedAssignment && this.visibleDelivs == 1 && this.firstLoad) {
						this.firstLoad = false;
						this.select(lastVisibleClass, lastVisibleDeliv);
					}
				});
			}
		},
		recordUploaded(){
			this.hideRecordModal();
			this.finished();
		},
		startUpload(){
			console.log("Starting on uploading the file")
		},
		saveFiles(dropzone) {
			this.submitting = true;
			let cid = this.selectedClass.id;
			let aid = this.selectedAssessment.id;
			let did = this.selectedAssignment.id;
			let iid = this.selectedAssessment.item.id;
			ResponseMediaService.responseHasMedia(cid, aid, did, iid, this.user.id)
				.then(r => {
					if (r.data) {
						console.log("Response has media:", r.data);
						Notie.error("Failed to upload work", "Files already exist for this assignment");
						this.finished();
					} else {
						console.log("Response has media:", r.data);
						console.log("Process queue from dropzone", dropzone, this.$refs[dropzone]);
						this.$refs[dropzone].processQueue();
					}
				})
				.catch(err => {
					this.submitting = false;
					Notie.error(`Failed to save files`, err);
				});
		},

		sendingEvent(file, xhr, formData) {
			formData.append("sids", JSON.stringify([this.user.id]));
			formData.append("name", file.name);
			// debugger;
		},

		dropzoneError(file, err) {
			if (err == "Upload canceled.") {
				//Squelch this error, it occurs in the course of normal operation
				return;
			}
			console.log({ "Dropzone error": err });
			Notie.error(`Failed to upload file '${file.name}'`, err);
		},
		showNotes(){
			this.showIt = ! this.showIt
			this.showItText =  (this.showIt === true) ? 'Hide Notes' : 'Show Notes';

		},
		finished(r) {
			console.log("Finished dropzone", r);
			this.submitting = false;
			this.selectedClass = null;
			this.selectedAssignment = null;
			this.selectedAssessment = null;
			this.loadData();
		},

		beforeWindowTooltip(delivery) {
			return `Submission window starts: <div class="_600 text-primary">${fs.medDate(
				delivery.window_start
			)}</div><div class="text-extra-muted">(${fs.sinceString(delivery.window_start)})</div>`;
		},

		afterWindowTooltip(delivery) {
			return `Submission window ended: <div class="_600 text-danger">${fs.medDate(
				delivery.window_end
			)}</div><div class="text-extra-muted">(${fs.sinceString(delivery.window_end)})</div>`;
		},

		pickGoogleUpload() {
			this.uploadFrom = "google";
			this.connectGoogleDrive(true);
		},

		connectGoogleDrive(doSignIn) {
			if (!this.googleAuth) {
				console.log("Create auth object 2");
				this.googleAuth = gapi.auth2.getAuthInstance();
				this.googleAuth.isSignedIn.listen(resp => {
					console.log("LISTENER 2", resp);
					this.isSignedIn = this.googleAuth.isSignedIn.get();
					if (this.isSignedIn) {
						this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();

						let id = this.$route.params.studentID;
						store.set(this, "allowedGoogleSession", {
							[id]: this.googleUser.getId()
						});
					} else {
						this.googleUser = null;
						this.isSignedIn = null;
					}
				});

				this.isSignedIn = this.googleAuth.isSignedIn.get();

				if (this.isSignedIn) {
					this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();
				}

				if (!this.isSignedIn && doSignIn) {
					console.log("SIGNIN 1");
					this.googleAuth.signIn().catch(e => {
						this.uploadFrom = this.canUseCamera ? "camera" : "computer";
					});
				}
			} else {
				this.googleUser = this.googleAuth.currentUser.get().getBasicProfile();
				if (!this.isSignedIn && doSignIn) {
					console.log("SIGNIN 2");
					this.googleAuth.signIn().catch(e => {
						this.uploadFrom = this.canUseCamera ? "camera" : "computer";
					});
				}
			}
		},

		saveGoogleFiles() {
			if (!(this.googleFiles && this.googleFiles.length > 0)) {
				return;
			}

			this.submitting = true;
			let cid = this.selectedClass.id;
			let aid = this.selectedAssessment.id;
			let did = this.selectedAssignment.id;
			let iid = this.selectedAssessment.item.id;
			ResponseMediaService.responseHasMedia(cid, aid, did, iid, this.user.id)
				.then(r => {
					if (r.data) {
						Notie.error("Failed to upload work", "Files already exist for this assignment");
						this.finished();
					} else {
						BB.map(this.googleFiles, f => {
							return ResponseMediaService.addGDriveMediaExternal(
								cid,
								aid,
								did,
								iid,
								gapi,
								f,
								[this.user.id],
								this.user.id
							).catch(err => {
								console.log(err);
								Notie.error(`Failed to save file ${f.name}`, err);
							});
						}).then(r => {
							this.finished();
						});
					}
				})
				.catch(err => {
					Notie.error(`Failed to save files`, err);
				});
		},

		ensureSavedSession() {
			let id = this.$route.params.studentID;
			let doLogOut = true;
			let allowedGoogleSession = store.get(this, "allowedGoogleSession");
			console.log(allowedGoogleSession, id, this.googleUser.getId());
			if (allowedGoogleSession) {
				if (allowedGoogleSession[id] == this.googleUser.getId()) {
					doLogOut = false;
				}
			}

			if (doLogOut) {
				console.log("No Google user match, log out existing user");
				this.googleAuth
					.signOut()
					.then(() => {
						console.log("Signout successful");
					})
					.catch(e => {
						console.log(e);
					});
			}
		},

		changeUser() {
			this.googleUser = null;
			this.isSignedIn = false;
			this.googleAuth.signOut().then(() => {
				console.log("Change user signout successful");
				this.googleAuth.signIn().catch(e => {
					this.uploadFrom = this.canUseCamera ? "camera" : "computer";
				});
			});
		},

		logout() {
			if (this.googleAuth) {
				this.googleAuth.signOut().then(() => {
					console.log("Close signout successful");
					this.loggedOut = true;
					history.replaceState({}, null, "/#/submit/logout");
				});
			} else {
				this.loggedOut = true;
				history.replaceState({}, null, "/#/submit/logout");
			}
		},

		removeIfUnsupported(files) {
			let supported = false;
			for (let file of files) {
				console.log("file.type: ", file.type);
				if (unsupportedMTs.includes(file.type)) {
					this.$refs.myVueDropzone.removeFile(file);
					Notie.error("Unsupported File Type");
				}
			}
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.text-primary:hover {
	text-decoration: underline;
}
.lower-right {
	position: absolute;
	bottom: 0.5rem;
	right: 1rem;
}
.clickable:hover {
	cursor: pointer;
	background-color: #eeeeee;
}
.clickable-back {
	padding: 8px;
	border-radius: 8px;
	margin-top: -8px;
	margin-bottom: -8px;
}
.clickable-back:hover {
	background-color: #eeeeee;
}
.clickable-text {
	cursor: pointer;
	transition: opacity 0.15s ease-in-out;
}
.clickable-text:hover {
	opacity: 0.7;
}
.selected-submitted {
	box-shadow: 0 0 4px 1px #22b66e inset;
}
.selected-row {
	box-shadow: 0 0 4px 1px #53a6fa inset;
}
.top-right {
	position: absolute;
	top: 8px;
	right: 8px;
	width: 32px;
	height: 32px;
	background-color: rgba(255, 0, 0, 0.1);
}
.dropdown-item.active {
	color: #fff !important;
}
.dropdown-item.active:hover {
	background-color: #007bff !important;
}
.dropdown-item i {
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/vues/Scan/SubmitWork.vue